import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 6a6 6 0 0 1 6-6h36a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#99C3FF",
  d: "M18.119 10.664H11.54c-.709 0-1.123.74-.717 1.279l5.572 7.339c.836 1.101 2.377 1.263 3.608.631 1.606-.825 2.705-2.953 1.711-4.461l-2.663-4.04c-.155-.235-.275-.519-.524-.65a.9.9 0 0 0-.41-.098m19.624 0h-6.53a.89.89 0 0 0-.751.395l-2.869 4.39c-.988 1.514.116 3.637 1.724 4.462 1.234.633 2.78.47 3.619-.635l5.567-7.332c.41-.54-.006-1.28-.76-1.28"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0068FF",
  d: "M23.997 18.664a9.33 9.33 0 0 0-9.333 9.333 9.33 9.33 0 0 0 9.333 9.334 9.33 9.33 0 0 0 9.334-9.334 9.33 9.33 0 0 0-9.334-9.333m4.906 8.342a5.36 5.36 0 0 0-1.538 4.733.606.606 0 0 1-.882.636 5.35 5.35 0 0 0-4.973-.003.606.606 0 0 1-.882-.636 5.36 5.36 0 0 0-1.538-4.733c-.364-.353-.157-.968.341-1.042a5.34 5.34 0 0 0 4.02-2.922.59.59 0 0 1 .544-.338c.218 0 .437.115.543.338a5.35 5.35 0 0 0 4.024 2.923.61.61 0 0 1 .34 1.044"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }